export function isBlankFrame(pixels: Uint8ClampedArray, threshold = 4): boolean {
  let sum = 0;
  let sumSq = 0;
  let n = 0;
  for (let i = 0; i < pixels.length; i += 4) {
    const luma = ((pixels[i] ?? 0) + (pixels[i + 1] ?? 0) + (pixels[i + 2] ?? 0)) / 3;
    sum += luma;
    sumSq += luma * luma;
    n++;
  }
  const mean = sum / n;
  const variance = sumSq / n - mean * mean;
  return Math.sqrt(variance) < threshold;
}

/** Average-hash over luma. `pixels` should already be a small downsampled
 * frame (the canvas-drawing caller owns that); hashes whatever length it's
 * given, so both sides of a comparison must use the same sample count. */
export function averageHash(pixels: Uint8ClampedArray): string {
  const lumas: number[] = [];
  for (let i = 0; i < pixels.length; i += 4) {
    lumas.push(((pixels[i] ?? 0) + (pixels[i + 1] ?? 0) + (pixels[i + 2] ?? 0)) / 3);
  }
  const mean = lumas.reduce((a, b) => a + b, 0) / lumas.length;
  return lumas.map(l => (l >= mean ? "1" : "0")).join("");
}

export function hammingDistance(a: string, b: string): number {
  let d = 0;
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) d++;
  return d;
}

export function isNearDuplicate(a: string, b: string, threshold = 6): boolean {
  return hammingDistance(a, b) <= threshold;
}
